const data = {
    "types": [
        'Flat',
        'Mess',
        'Hostel',
        'Sublet',
        'Rommate',
        'Office'
    ]
}

export default data;
